import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import { useState } from 'react';
import ReactPlayer from 'react-player';
const CustomVideoPlayer = ({ videoPath, isDelete, deleteImage, isFile, removeImage, index }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const handleDelete = () => {
        if (isFile) deleteImage(index);
        else removeImage(index);
    };
    return (
        <div className="video-wrap" sx={{ zIndex: 999 }}>
            <ReactPlayer
                url={videoPath}
                playing={isPlaying}
                // onEnded={() => setIsPlaying(false)}
                fallback={''}
                controls
                loop={false}
                onPlay={() => setIsPlaying(true)}
                onPause={() => setIsPlaying(false)}
            />
            {isDelete && (
                <IconButton className="media-close" onClick={handleDelete} sx={{ marginLeft: 'auto' }}>
                    <Close />
                </IconButton>
            )}
        </div>
    );
};
export default CustomVideoPlayer;
